// import React, { useEffect, useState } from "react";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
// import { useNavigate, useParams } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";

// // Updated interfaces to match YOUR ACTUAL API response
// interface Timeline {
//   orderPlaced: string;
//   deliveryAssigned: string | null;
//   orderShipped: string | null;
//   delivered: string | null;
//   status: string;
//   technician: string;
// }

// interface PatientInfo {
//   username: string;
//   contactNumber: string;
//   address: string;
//   age: number;
// }

// interface OrderInfo {
//   totalItems: number;
//   subtotal: number;
//   deliveryFee: number;
//   payment: string;
//   itemsName: string;
// }

// interface DeliveryDetails {
//   technicianName: string;
//   technicianStatus: string;
//   deliveryStatus: string;
//   orderId: string;
//   receivedDateTime: string | null;
//   locationUrl: string | null;
//   deliveryAddress: string;
//   sampleCollectionType: string;
//   scheduledate: string;
//   startTime: string;
//   endTime: string;
// }

// interface PaymentInfo {
//   paymentStatus: string;
//   orderPrice: number;
//   deliveryPrice: number;
//   paymentMode: string;
//   invoiceUrl: string;
// }

// interface LabBookingDetails {
//   timeline: Timeline;
//   patient: PatientInfo;
//   orderInfo: OrderInfo;
//   report: any;
//   deliveryDetails: DeliveryDetails;
//   paymentInfo: PaymentInfo;
// }

// interface ApiResponse {
//   status: boolean; // ← CHANGED FROM 'success' to 'status'
//   message: string;
//   data: LabBookingDetails;
// }

// export const LabOrderDetails: React.FC<any> = React.memo((props) => {
//   const { control, register, handleSubmit, setValue } = useForm();
//   const [loading, setLoading] = useState<boolean>(false);
//   const [bookingData, setBookingData] = useState<LabBookingDetails | null>(
//     null
//   );
//   const [error, setError] = useState<string | null>(null);
//   const params = useParams<{ id: string }>();
//   const orderId = params?.id;

//   const onSubmit = () => {};

//   // Fixed API call - using 'status' instead of 'success'
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!orderId) {
//         setError("No order ID found in URL");
//         return;
//       }

//       setLoading(true);
//       setError(null);

//       try {
//         console.log(`🔄 Fetching data for orderId: ${orderId}`);
//         const response: ApiResponse = await callAPI(
//           `lab/LabBooking/LabBooking-details/${orderId}`,
//           Method.GET
//         );

//         console.log("📦 API Response:", response);

//         // FIXED: Check 'status' instead of 'success'
//         if (response?.status === true && response.data) {
//           console.log("✅ Data loaded successfully!");
//           setBookingData(response.data);
//           setValue("status", response.data.timeline?.status || "");
//           setError(null);
//         } else {
//           console.error("❌ Invalid response:", response);
//           setError(
//             `API Error: ${response?.message || "Invalid response structure"}`
//           );
//         }
//       } catch (err: any) {
//         console.error("💥 API Error:", err);
//         setError(`Failed to fetch: ${err.message || "Network error"}`);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [orderId, control]);

//   useEffect(() => {
//     if (orderId) {
//       breadCrumbsStore.updateBreadCrumbs([
//         { Orders: "lab-orders/list" },
//         { [`Order Details `]: "/" },
//       ]);
//     }
//   }, [orderId]);

//   // Dynamic timeline based on status
//   const steps = bookingData
//     ? [
//         {
//           label: "Order Placed",
//           completed: bookingData.timeline.orderPlaced !== "OrderPlaced",
//           icon: <WSIcons.FiPackage />,
//         },
//         {
//           label: "Technician Assigned",
//           completed:
//             bookingData.timeline.status !== "OrderPlaced" &&
//             bookingData.timeline.technician !== "Not Assigned",
//           icon: <WSIcons.TbUserSquareRounded />,
//         },
//         {
//           label: "Sample Collected",
//           completed:
//             bookingData.timeline.status === "SampleCollected" ||
//             bookingData.timeline.status === "Report Generated",
//           icon: <WSIcons.RiRidingLine />,
//         },
//         {
//           label: "Report Uploaded",
//           completed: bookingData.timeline.status === "Report Generated",
//           icon: <WSIcons.BsArrowUpSquare />,
//         },
//       ]
//     : [];

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography>
//             Loading booking details for Order ID: {orderId}...
//           </Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (error || !bookingData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//         <Paper
//           style={{
//             padding: 20,
//             marginTop: 20,
//             borderRadius: "8px",
//             backgroundColor: "#fff3cd",
//           }}
//         >
//           <Typography variant="h6" color="warning.main" gutterBottom>
//             No Booking Data Found
//           </Typography>
//           {/* <Typography gutterBottom>
//             <strong>Order ID:</strong> {orderId || "Missing"}
//           </Typography>
//           <Typography color="error">
//             {error || "No booking data available"}
//           </Typography> */}
//         </Paper>
//       </>
//     );
//   }

//   // ✅ NOW DATA WILL DISPLAY CORRECTLY!
//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//       <form onSubmit={handleSubmit(onSubmit)}>
//         {/* Order Timeline */}
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 20,
//             paddingBottom: 25,
//             borderRadius: "8px",
//           }}
//         >
//           <Grid container spacing={2}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                 Order Timeline
//               </Typography>
//             </Grid>
//             <Grid item sm={12} xs={12}>
//               <WSHorizontalTimeline steps={steps} />
//               <Typography
//                 color={"GrayText"}
//                 variant="caption"
//                 style={{ fontWeight: 400, marginTop: 10 }}
//               >
//                 {bookingData.timeline.orderPlaced}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Order Summary */}
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 20,
//             paddingBottom: 25,
//             borderRadius: "8px",
//           }}
//         >
//           <Grid container spacing={2} mt={2}>
//             <Grid item sm={3} xs={12}>
//               <Typography>Order ID</Typography>
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <Typography>Status</Typography>
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <Typography>Technician</Typography>
//             </Grid>
           
//             <Grid item xs={12}>
//               <Divider style={{ marginTop: 10 }} />
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <Typography>{bookingData.deliveryDetails.orderId}</Typography>
//             </Grid>
//             <Grid item sm={3} xs={12}>
           
//                 <WSTextField
//                 label=""
//                 {...register("status")}
//                 id="status"
//                 name="status"
//                 control={control}
//                 rules={{ required: false }}
//                 sx={{ width: "131px" }}
//                 defaultValue={bookingData.timeline.status}
//               />
//             </Grid>
//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 label=""
//                 {...register("technician")}
//                 id="technician"
//                 name="technician"
//                 control={control}
//                 rules={{ required: false }}
//                 sx={{ width: "131px" }}
//                 defaultValue={bookingData.timeline.technician}
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Patient & Order Info */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                     Patient Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Patient Name
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.username}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Age
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.age}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Contact Number
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.contactNumber}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Address
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.address}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Patient ID
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.deliveryDetails.orderId}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//                 height: "19rem",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                     Order Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Test / Package Name
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     : {bookingData.orderInfo.itemsName}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Order Date & Time
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     :{" "}
//                     {new Date(
//                       bookingData.timeline.orderPlaced
//                     ).toLocaleString()}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Sample Collection Type
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     : {bookingData.deliveryDetails.sampleCollectionType}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Scheduled Collection Slot
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     :{" "}
//                     {`${bookingData.deliveryDetails.scheduledate} ${bookingData.deliveryDetails.startTime} - ${bookingData.deliveryDetails.endTime}`}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Collection & Processing Details */}
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 40,
//             paddingBottom: 25,
//             borderRadius: "8px",
//           }}
//         >
//           <Grid container spacing={2}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                 Collection & Processing Details
//               </Typography>
//             </Grid>
//             <Grid item xs={12}>
//               <Divider />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Assigned Technician:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <WSTextField
//                 control={control}
//                 id="technicianName"
//                 name="technicianName"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={bookingData.deliveryDetails.technicianName}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Technician Status:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 {bookingData.deliveryDetails.technicianStatus}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Collection Status:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <WSSelectField
//                 rules={{ required: true }}
//                 {...register("collected")}
//                 id="collected"
//                 control={control}
//                 label=""
//                 name="collected"
//                 // options={bookingData.deliveryDetails.technicianStatus}
//                 sx={{ mt: 2, width: 150 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Sample ID
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 {bookingData.deliveryDetails.orderId}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Sample Received Date & Time
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 {" "}
//                 {bookingData.deliveryDetails.receivedDateTime
//                   ? new Date(
//                       bookingData.deliveryDetails.receivedDateTime
//                     ).toLocaleString()
//                   : ""}
//               </Typography>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Collection Location:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <WSTextField
//                 control={control}
//                 id="collectionLocation"
//                 name="collectionLocation"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={bookingData.deliveryDetails.deliveryAddress}
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Payment Information */}
//         <Grid container spacing={2} mt={3}>
//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//                 height: "19rem",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                     Payment Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Payment Status
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     {" "}
//                     : {bookingData.paymentInfo.paymentStatus}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Test / Package Price
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     {" "}
//                     : ₹{bookingData.paymentInfo.orderPrice}/-
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Collection Price
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     {" "}
//                     : ₹{bookingData.paymentInfo.deliveryPrice}/-
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Invoice
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography
//                     variant="body2"
//                     style={{ color: "#098963" }}
//                     mt={2}
//                   >
//                     : {bookingData.paymentInfo.invoiceUrl || " "}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>
//       </form>
//     </>
//   );
// });





// import React, { useEffect, useState } from "react";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
// import { useNavigate, useParams } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import { LabInvoiceReport } from "./invoice";

// // Updated interfaces to match YOUR ACTUAL API response
// interface Timeline {
//   orderPlaced: string;
//   deliveryAssigned: string | null;
//   orderShipped: string | null;
//   delivered: string | null;
//   status: string;
//   technician: string;
// }

// interface PatientInfo {
//   username: string;
//   contactNumber: string;
//   address: string;
//   age: number;
// }

// interface OrderInfo {
//   totalItems: number;
//   subtotal: number;
//   deliveryFee: number;
//   payment: string;
//   itemsName: string;
// }

// interface DeliveryDetails {
//   technicianName: string;
//   technicianStatus: string;
//   deliveryStatus: string;
//   orderId: string;
//   receivedDateTime: string | null;
//   locationUrl: string | null;
//   deliveryAddress: string;
//   sampleCollectionType: string;
//   scheduledate: string;
//   startTime: string;
//   endTime: string;
// }

// interface PaymentInfo {
//   paymentStatus: string;
//   orderPrice: number;
//   deliveryPrice: number;
//   paymentMode: string;
//   invoiceUrl: string;
// }

// interface LabBookingDetails {
//   timeline: Timeline;
//   patient: PatientInfo;
//   orderInfo: OrderInfo;
//   report: any;
//   deliveryDetails: DeliveryDetails;
//   paymentInfo: PaymentInfo;
// }

// interface ApiResponse {
//   status: boolean; // ← CHANGED FROM 'success' to 'status'
//   message: string;
//   data: LabBookingDetails;
// }



// export const LabOrderDetails: React.FC<any> = React.memo((props) => {
//   const { control, register, handleSubmit, setValue } = useForm();
//   const [loading, setLoading] = useState<boolean>(false);
//   const [bookingData, setBookingData] = useState<LabBookingDetails | null>(null);
//   const [error, setError] = useState<string | null>(null);
//   const [invoiceModalOpen, setInvoiceModalOpen] = useState(false); // ✅ NEW STATE
//   const params = useParams<{ id: string }>();
//   const orderId = params?.id;

//   // ✅ NEW FUNCTION - exactly like pharmacy
//   const handleOpenInvoice = () => {
//     setInvoiceModalOpen(true);
//   };

//   const onSubmit = () => {};

//   // Fixed API call - using 'status' instead of 'success'
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!orderId) {
//         setError("No order ID found in URL");
//         return;
//       }

//       setLoading(true);
//       setError(null);

//       try {
//         console.log(`🔄 Fetching data for orderId: ${orderId}`);
//         const response: ApiResponse = await callAPI(
//           `lab/LabBooking/LabBooking-details/${orderId}`,
//           Method.GET
//         );

//         console.log("📦 API Response:", response);

//         // FIXED: Check 'status' instead of 'success'
//         if (response?.status === true && response.data) {
//           console.log("✅ Data loaded successfully!");
//           setBookingData(response.data);
//           setValue("status", response.data.timeline?.status || "");
//           setError(null);
//         } else {
//           console.error("❌ Invalid response:", response);
//           setError(
//             `API Error: ${response?.message || "Invalid response structure"}`
//           );
//         }
//       } catch (err: any) {
//         console.error("💥 API Error:", err);
//         setError(`Failed to fetch: ${err.message || "Network error"}`);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [orderId, control]);

//   useEffect(() => {
//     if (orderId) {
//       breadCrumbsStore.updateBreadCrumbs([
//         { Orders: "lab-orders/list" },
//         { [`Order Details `]: "/" },
//       ]);
//     }
//   }, [orderId]);

//   // Dynamic timeline based on status
//   const steps = bookingData
//     ? [
//         {
//           label: "Order Placed",
//           completed: bookingData.timeline.orderPlaced !== "OrderPlaced",
//           icon: <WSIcons.FiPackage />,
//         },
//         {
//           label: "Technician Assigned",
//           completed:
//             bookingData.timeline.status !== "OrderPlaced" &&
//             bookingData.timeline.technician !== "Not Assigned",
//           icon: <WSIcons.TbUserSquareRounded />,
//         },
//         {
//           label: "Sample Collected",
//           completed:
//             bookingData.timeline.status === "SampleCollected" ||
//             bookingData.timeline.status === "Report Generated",
//           icon: <WSIcons.RiRidingLine />,
//         },
//         {
//           label: "Report Uploaded",
//           completed: bookingData.timeline.status === "Report Generated",
//           icon: <WSIcons.BsArrowUpSquare />,
//         },
//       ]
//     : [];

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography>
//             Loading booking details for Order ID: {orderId}...
//           </Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (error || !bookingData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//         <Paper
//           style={{
//             padding: 20,
//             marginTop: 20,
//             borderRadius: "8px",
//             backgroundColor: "#fff3cd",
//           }}
//         >
//           <Typography variant="h6" color="warning.main" gutterBottom>
//             No Booking Data Found
//           </Typography>
//         </Paper>
//       </>
//     );
//   }

//   // ✅ NOW DATA WILL DISPLAY CORRECTLY!
//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//       <form onSubmit={handleSubmit(onSubmit)}>
//         {/* Order Timeline */}
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 20,
//             paddingBottom: 25,
//             borderRadius: "8px",
//           }}
//         >
//           <Grid container spacing={2}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                 Order Timeline
//               </Typography>
//             </Grid>
//             <Grid item sm={12} xs={12}>
//               <WSHorizontalTimeline steps={steps} />
//               <Typography
//                 color={"GrayText"}
//                 variant="caption"
//                 style={{ fontWeight: 400, marginTop: 10 }}
//               >
//                 {bookingData.timeline.orderPlaced}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Order Summary */}
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 20,
//             paddingBottom: 25,
//             borderRadius: "8px",
//           }}
//         >
//           <Grid container spacing={2} mt={2}>
//             <Grid item sm={3} xs={12}>
//               <Typography>Order ID</Typography>
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <Typography>Status</Typography>
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <Typography>Technician</Typography>
//             </Grid>
            
//             <Grid item xs={12}>
//               <Divider style={{ marginTop: 10 }} />
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <Typography>{bookingData.deliveryDetails.orderId}</Typography>
//             </Grid>
//             <Grid item sm={3} xs={12}>
//               <WSTextField
//                 label=""
//                 {...register("status")}
//                 id="status"
//                 name="status"
//                 control={control}
//                 rules={{ required: false }}
//                 sx={{ width: "131px" }}
//                 defaultValue={bookingData.timeline.status}
//               />
//             </Grid>
//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 label=""
//                 {...register("technician")}
//                 id="technician"
//                 name="technician"
//                 control={control}
//                 rules={{ required: false }}
//                 sx={{ width: "131px" }}
//                 defaultValue={bookingData.timeline.technician}
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Patient & Order Info */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                     Patient Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Patient Name
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.username}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Age
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.age}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Contact Number
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.contactNumber}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Address
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.patient.address}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}>
//                   <Typography variant="body2" color="GrayText">
//                     Patient ID
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">
//                     : {bookingData.deliveryDetails.orderId}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//                 height: "19rem",
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                     Order Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Test / Package Name
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     : {bookingData.orderInfo.itemsName}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Order Date & Time
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     :{" "}
//                     {new Date(
//                       bookingData.timeline.orderPlaced
//                     ).toLocaleString()}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Sample Collection Type
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     : {bookingData.deliveryDetails.sampleCollectionType}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText">
//                     Scheduled Collection Slot
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2">
//                     :{" "}
//                     {`${bookingData.deliveryDetails.scheduledate} ${bookingData.deliveryDetails.startTime} - ${bookingData.deliveryDetails.endTime}`}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Collection & Processing Details */}
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 40,
//             paddingBottom: 25,
//             borderRadius: "8px",
//           }}
//         >
//           <Grid container spacing={2}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                 Collection & Processing Details
//               </Typography>
//             </Grid>
//             <Grid item xs={12}>
//               <Divider />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Assigned Technician:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <WSTextField
//                 control={control}
//                 id="technicianName"
//                 name="technicianName"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={bookingData.deliveryDetails.technicianName}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Technician Status:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 {bookingData.deliveryDetails.technicianStatus}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Collection Status:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <WSSelectField
//                 rules={{ required: true }}
//                 {...register("collected")}
//                 id="collected"
//                 control={control}
//                 label=""
//                 name="collected"
//                 sx={{ mt: 2, width: 150 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Sample ID
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 {bookingData.deliveryDetails.orderId}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Sample Received Date & Time
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 {" "}
//                 {bookingData.deliveryDetails.receivedDateTime
//                   ? new Date(
//                       bookingData.deliveryDetails.receivedDateTime
//                     ).toLocaleString()
//                   : ""}
//               </Typography>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>
//                 Collection Location:
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <WSTextField
//                 control={control}
//                 id="collectionLocation"
//                 name="collectionLocation"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={bookingData.deliveryDetails.deliveryAddress}
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Payment Information - ✅ MODIFIED WITH CLICKABLE VIEW INVOICE */}
//         <Grid container spacing={2} mt={3}>
//           <Grid item xs={12} sm={6}>
//             <Paper
//               elevation={0}
//               style={{
//                 paddingLeft: 20,
//                 paddingRight: 20,
//                 marginTop: 0,
//                 paddingBottom: 25,
//                 borderRadius: "8px",
//                 height: "24rem", // ✅ Increased height to match pharmacy
//               }}
//             >
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                     Payment Information
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Payment Status
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     : {bookingData.paymentInfo.paymentStatus}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Test / Package Price
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     : ₹{bookingData.paymentInfo.orderPrice.toFixed(2)}/-
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Collection Price
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     : ₹{bookingData.paymentInfo.deliveryPrice.toFixed(2)}/-
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Payment Method
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" mt={2}>
//                     : {bookingData.paymentInfo.paymentMode}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Total
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="body2" fontWeight="bold" mt={2}>
//                     : ₹{(bookingData.paymentInfo.orderPrice + bookingData.paymentInfo.deliveryPrice).toFixed(2)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="body2" color="GrayText" mt={2}>
//                     Invoice
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}> 
//                   <Typography 
//                     style={{ 
//                       color: "#098963", 
//                       cursor: "pointer", 
//                       textDecoration: "underline" 
//                     }} 
//                     mt={2}
//                     onClick={handleOpenInvoice} // ✅ CLICKABLE VIEW INVOICE
//                   >
//                     View Invoice
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>
//       </form>

//       {/* ✅ INVOICE MODAL - EXACTLY LIKE PHARMACY */}
//       <Dialog 
//         open={invoiceModalOpen} 
//         onClose={() => setInvoiceModalOpen(false)}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{ sx: { height: "90vh" } }}
//       >
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <Typography variant="h6">Lab Invoice</Typography>
//           <IconButton onClick={() => setInvoiceModalOpen(false)}>
//             <WSIcons.CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
//           {orderId && <LabInvoiceReport orderId={orderId} />}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// });






// import React, { useEffect, useState, useCallback } from "react";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
// import { useParams } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import { LabInvoiceReport } from "./invoice";

// // INTERFACES - SAME
// interface Timeline {
//   orderPlaced: string;
//   deliveryAssigned: string | null;
//   orderShipped: string | null;
//   delivered: string | null;
//   status: string;
//   technician: string;
// }

// interface PatientInfo {
//   username: string;
//   contactNumber: string;
//   address: string;
//   age: number;
// }

// interface OrderInfo {
//   totalItems: number;
//   subtotal: number;
//   deliveryFee: number;
//   payment: string;
//   itemsName: string;
// }

// interface DeliveryDetails {
//   technicianName: string;
//   technicianStatus: string;
//   deliveryStatus: string;
//   orderId: string;
//   receivedDateTime: string | null;
//   locationUrl: string | null;
//   deliveryAddress: string;
//   sampleCollectionType: string;
//   scheduledate: string;
//   startTime: string;
//   endTime: string;
// }

// interface PaymentInfo {
//   paymentStatus: string;
//   orderPrice: number;
//   deliveryPrice: number;
//   paymentMode: string;
//   invoiceUrl: string;
// }

// interface PatientTest {
//   labBookingServiceId: string;
//   labBookingPatientId: string;
//   testName: string;
//   status: string;
//   reportUrl: string;
// }

// interface BookingPatient {
//   patientId: string;
//   patientName: string;
//   tests: PatientTest[];
// }

// interface LabBookingDetails {
//   timeline: Timeline;
//   patient: PatientInfo;
//   orderInfo: OrderInfo;
//   report: any;
//   deliveryDetails: DeliveryDetails;
//   paymentInfo: PaymentInfo;
//   patients: BookingPatient[];
// }

// interface ApiResponse {
//   status: boolean;
//   message: string;
//   data: LabBookingDetails;
// }

// export const LabOrderDetails: React.FC<any> = React.memo((props) => {
//   const params = useParams<{ id: string }>();
//   const orderId = params?.id;
  
//   const mainForm = useForm<any>();
//   const { control: mainControl, register: mainRegister, handleSubmit: mainHandleSubmit, setValue: mainSetValue, getValues } = mainForm;

//   const [loading, setLoading] = useState<boolean>(false);
//   const [bookingData, setBookingData] = useState<LabBookingDetails | null>(null);
//   const [error, setError] = useState<string | null>(null);
//   const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  
//   // ✅ FIXED: File upload states
//   const [reportFiles, setReportFiles] = useState<{ [key: string]: File | null }>({});
//   const [uploadingReports, setUploadingReports] = useState<{ [key: string]: boolean }>({});
//   const [uploadSuccess, setUploadSuccess] = useState<{ [key: string]: boolean }>({});

//   // ✅ INVOICE UPLOAD STATES - ADD THESE
// const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
// const [uploadingInvoice, setUploadingInvoice] = useState(false);
// const [uploadInvoiceSuccess, setUploadInvoiceSuccess] = useState(false);


//   const handleOpenInvoice = () => {
//     setInvoiceModalOpen(true);
//   };

//   const onSubmit = () => {};

//   // FETCH DATA
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!orderId) {
//         setError("No order ID found in URL");
//         return;
//       }

//       setLoading(true);
//       setError(null);

//       try {
//         console.log(`🔄 Fetching data for orderId: ${orderId}`);
//         const response: ApiResponse = await callAPI(
//           `lab/LabBooking/LabBooking-details/${orderId}`,
//           Method.GET
//         );

//         console.log("📦 API Response:", response);

//         if (response?.status === true && response.data) {
//           console.log("✅ Data loaded successfully!");
//           setBookingData(response.data);
//           mainSetValue("status", response.data.timeline?.status || "");
//           setError(null);
//         } else {
//           console.error("❌ Invalid response:", response);
//           setError(`API Error: ${response?.message || "Invalid response structure"}`);
//         }
//       } catch (err: any) {
//         console.error("💥 API Error:", err);
//         setError(`Failed to fetch: ${err.message || "Network error"}`);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [orderId, mainSetValue]);

//   // ✅ FIXED: File handlers with react-hook-form COMPATIBILITY
//   const handleFileChange = useCallback((labBookingPatientId: string, fieldName: string) => {
//     const fileList = getValues(fieldName) as FileList;
//     if (fileList && fileList.length > 0) {
//       const file = fileList[0];
//       setReportFiles(prev => ({ ...prev, [labBookingPatientId]: file }));
//       console.log(`📁 Selected file for ${labBookingPatientId}:`, file.name);
//     }
//   }, [getValues]);

//   const handleReportUpload = useCallback(async (labBookingPatientId: string, testName: string, fieldName: string) => {
//   const fileList = getValues(fieldName) as FileList;
//   const file = fileList?.[0];
  
//   if (!file) {
//     alert(`Please select a report file for ${testName}`);
//     return;
//   }

//   // ✅ FIXED: Get UserId (which IS labId)
//   const userId = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
//   if (!userId) {
//     alert('❌ UserId not found. Please login again.');
//     return;
//   }
  
//   console.log('🔑 UserId (labId):', userId); // DEBUG

//   const patientKey = labBookingPatientId;
//   setUploadingReports(prev => ({ ...prev, [patientKey]: true }));
//   setUploadSuccess(prev => ({ ...prev, [patientKey]: false }));

//   try {
//     const formData = new FormData();
//     formData.append("reportFile", file);

//     console.log('📤 Uploading file:', file.name);

//     // ✅ FIXED: Use your ORIGINAL working callAPI + CORRECT ENDPOINT
//     const response = await callAPI(
//       `lab/LabBooking/upload-report?labBookingPatientId=${labBookingPatientId}&UpdatedBy=${userId}`,
//       Method.POST,
//       formData
//     );

//     console.log()

//     console.log('✅ API Response:', response);

//     if (response?.status === true) {
//       setUploadSuccess(prev => ({ ...prev, [patientKey]: true }));
//       alert(`✅ Report uploaded successfully for ${testName}!`);
//       mainSetValue(fieldName, null as any);
//       setReportFiles(prev => ({ ...prev, [labBookingPatientId]: null }));
//       setTimeout(() => window.location.reload(), 1500);
//     } else {
//       throw new Error(response?.message || 'Upload failed');
//     }

//   } catch (err: any) {
//     console.error('❌ Upload error:', err);
//     alert(`❌ Failed to upload ${testName}: ${err.message || 'Please try again'}`);
//   } finally {
//     setUploadingReports(prev => ({ ...prev, [patientKey]: false }));
//     setTimeout(() => {
//       setUploadSuccess(prev => ({ ...prev, [patientKey]: false }));
//     }, 3000);
//   }
// }, [getValues, mainSetValue]);


// // ✅ INVOICE UPLOAD HANDLER - ADD THIS
// const handleInvoiceUpload = useCallback(async () => {
//     const file = invoiceFile;
    
//     if (!file) {
//         alert('Please select an invoice file first');
//         return;
//     }

//     if (!orderId) {
//         alert('No order ID found');
//         return;
//     }

//     // ✅ Get UserId (same as report upload)
//     const userId = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
//     if (!userId) {
//         alert('❌ UserId not found. Please login again.');
//         return;
//     }

//     setUploadingInvoice(true);
//     setUploadInvoiceSuccess(false);

//     try {
//         const formData = new FormData();
//         formData.append("file", file); // ✅ Matches your API request body

//         console.log('📤 Uploading invoice:', file.name);

//         // ✅ YOUR EXACT API ENDPOINT
//         const response = await callAPI(
//             `lab/LabBooking/${orderId}/upload-invoice`, // ✅ POST/api/lab/LabBooking/{orderId}/upload-invoice
//             Method.POST,
//             formData
//         );

//         console.log('✅ INVOICE UPLOAD Response:', response);

//         if (response?.status === true) {
//             setUploadInvoiceSuccess(true);
//             alert('✅ Invoice uploaded successfully!');
//             setInvoiceFile(null);
//             mainSetValue('invoiceFile', null as any);
//             setTimeout(() => window.location.reload(), 1500);
//         } else {
//             throw new Error(response?.message || 'Invoice upload failed');
//         }

//     } catch (err: any) {
//         console.error('❌ Invoice upload error:', err);
//         alert(`❌ Failed to upload invoice: ${err.message || 'Please try again'}`);
//     } finally {
//         setUploadingInvoice(false);
//         setTimeout(() => {
//             setUploadInvoiceSuccess(false);
//         }, 3000);
//     }
// }, [invoiceFile, orderId, mainSetValue]);





//   useEffect(() => {
//     if (orderId) {
//       breadCrumbsStore.updateBreadCrumbs([
//         { Orders: "lab-orders/list" },
//         { [`Order Details `]: "/" },
//       ]);
//     }
//   }, [orderId]);

//   const steps = bookingData
//     ? [
//         {
//           label: "Order Placed",
//           completed: bookingData.timeline.orderPlaced !== "OrderPlaced",
//           icon: <WSIcons.FiPackage />,
//         },
//         {
//           label: "Technician Assigned",
//           completed:
//             bookingData.timeline.status !== "OrderPlaced" &&
//             bookingData.timeline.technician !== "Not Assigned",
//           icon: <WSIcons.TbUserSquareRounded />,
//         },
//         {
//           label: "Sample Collected",
//           completed:
//             bookingData.timeline.status === "SampleCollected" ||
//             bookingData.timeline.status === "Report Generated",
//           icon: <WSIcons.RiRidingLine />,
//         },
//         {
//           label: "Report Uploaded",
//           completed: bookingData.timeline.status === "Report Generated",
//           icon: <WSIcons.BsArrowUpSquare />,
//         },
//       ]
//     : [];

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography>Loading booking details for Order ID: {orderId}...</Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (error || !bookingData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px", backgroundColor: "#fff3cd" }}>
//           <Typography variant="h6" color="warning.main" gutterBottom>No Booking Data Found</Typography>
//         </Paper>
//       </>
//     );
//   }

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
//       <form onSubmit={mainHandleSubmit(onSubmit)}>
//         {/* Timeline */}
//         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
//             </Grid>
//             <Grid item sm={12} xs={12}>
//               <WSHorizontalTimeline steps={steps} />
//               <Typography color={"GrayText"} variant="caption" style={{ fontWeight: 400, marginTop: 10 }}>
//                 {bookingData.timeline.orderPlaced}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Order Summary */}
//         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//           <Grid container spacing={2} mt={2}>
//             <Grid item sm={3} xs={12}><Typography>Order ID</Typography></Grid>
//             <Grid item sm={3} xs={12}><Typography>Status</Typography></Grid>
//             <Grid item sm={3} xs={12}><Typography>Technician</Typography></Grid>
//             <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
//             <Grid item sm={3} xs={12}><Typography>{bookingData.deliveryDetails.orderId}</Typography></Grid>
//             <Grid item sm={3} xs={12}>
//               <WSTextField
//                 label=""
//                 {...mainRegister("status")}
//                 id="status"
//                 name="status"
//                 control={mainControl}
//                 rules={{ required: false }}
//                 sx={{ width: "131px" }}
//                 defaultValue={bookingData.timeline.status}
//               />
//             </Grid>
//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 label=""
//                 {...mainRegister("technician")}
//                 id="technician"
//                 name="technician"
//                 control={mainControl}
//                 rules={{ required: false }}
//                 sx={{ width: "131px" }}
//                 defaultValue={bookingData.timeline.technician}
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* User & Order Info */}
//         <Grid container spacing={2} mt={2} sx={{ alignItems: 'stretch' }}>
//           <Grid item xs={12} sm={6}>
//             <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>👤 User Information</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">User Name</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.username}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Age</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.age}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.contactNumber}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.address}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Order ID</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.deliveryDetails.orderId}</Typography></Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>📋 Order Information</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Test Name</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.orderInfo.itemsName}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Order Date & Time</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(bookingData.timeline.orderPlaced).toLocaleString()}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sample Collection Type</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.deliveryDetails.sampleCollectionType}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Scheduled Collection Slot</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {`${bookingData.deliveryDetails.scheduledate} ${bookingData.deliveryDetails.startTime} - ${bookingData.deliveryDetails.endTime}`}</Typography></Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* ✅ FIXED: Patients & Tests - COMPLETE WORKING VERSION */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12}>
//             <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
//                 🧪 Patients & Tests Information
//               </Typography>
              
//               {bookingData.patients.map((bookingPatient, patientIndex) => (
//                 <React.Fragment key={bookingPatient.patientId}>
//                   <Grid item xs={12} sx={{ mt: 2 }}>
//                     <Divider />
//                     <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 1 }}>
//                       Patient {patientIndex + 1}: {bookingPatient.patientName}
//                     </Typography>
//                   </Grid>
                  
//                   {bookingPatient.tests.map((test) => {
//                     const fieldName = `report_${test.labBookingPatientId}`;
                    
//                     return (
//                       <Grid container key={test.labBookingServiceId} spacing={1} sx={{ pl: 3, mb: 2, pt: 1 }}>
//                         {/* Test Info */}
//                         <Grid item xs={12} sm={3}>
//                           <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Test:</Typography>
//                         </Grid>
//                         <Grid item xs={12} sm={9}>
//                           <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>{test.testName}</Typography>
//                         </Grid>
                        
//                         <Grid item xs={12} sm={3}>
//                           <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Status:</Typography>
//                         </Grid>
//                         <Grid item xs={12} sm={9}>
//                           <Typography variant="body2" sx={{ fontSize: '0.9rem', fontWeight: 'medium', color: test.status === "ReportGenerated" ? "success.main" : "warning.main" }}>
//                             {test.status.replace('ReportGenerated', 'Report Generated')}
//                           </Typography>
//                         </Grid>

//                         {/* Existing Report */}
//                         {test.reportUrl && (
//                           <>
//                             <Grid item xs={12} sm={3}>
//                               <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Report:</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={9}>
//                               <Typography 
//                                 variant="body2"
//                                 sx={{ fontSize: '0.9rem', color: "#098963", cursor: "pointer", textDecoration: "underline", '&:hover': { color: "#0a7a52" } }}
//                                 onClick={() => window.open(test.reportUrl, '_blank')}
//                               >
//                                 📄 View Report
//                               </Typography>
//                             </Grid>
//                           </>
//                         )}

//                         {/* ✅ FIXED FILE UPLOAD - react-hook-form COMPATIBLE */}
//                         <Grid item xs={12}>
//                           <Divider sx={{ my: 1 }} />
//                           <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem', mt: 1 }}>
//                             Upload New Report:
//                           </Typography>
//                           <Grid container spacing={2} sx={{ mt: 1 }}>
//                             <Grid item xs={12} sm={8}>
//                               <WSFileUpload
//                                 control={mainControl}
//                                 name={fieldName}
//                                 label="Select Report File (PDF/JPG/PNG)"
//                                 id={fieldName}
//                                 rules={{ required: false }}
//                                 onChange={() => handleFileChange(test.labBookingPatientId, fieldName)}
//                               />
//                               {reportFiles[test.labBookingPatientId] && (
//                                 <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
//                                   ✅ Selected: {reportFiles[test.labBookingPatientId]?.name}
//                                 </Typography>
//                               )}
//                             </Grid>
//                             <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
//                               <Button
//                                 variant="contained"
//                                 color="primary"
//                                 onClick={() => handleReportUpload(test.labBookingPatientId, test.testName, fieldName)}
//                                 disabled={uploadingReports[test.labBookingPatientId] || !reportFiles[test.labBookingPatientId]}
//                                 sx={{ mt: 1.5 }}
//                               >
//                                 {uploadingReports[test.labBookingPatientId] 
//                                   ? "⏳ Uploading..." 
//                                   : "🚀 Upload Report"
//                                 }
//                               </Button>
//                               {uploadSuccess[test.labBookingPatientId] && (
//                                 <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
//                                   ✓ Success
//                                 </Typography>
//                               )}
//                             </Grid>
//                           </Grid>
//                         </Grid>
//                       </Grid>
//                     );
//                   })}
//                 </React.Fragment>
//               ))}
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Payment Information */}
//         <Grid container spacing={2} mt={3}>
//           <Grid item xs={12} sm={6}>
//             <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
//               <Grid container spacing={2} mt={0}>
//                 <Grid item sm={12} xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>💰 Payment Information</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: {bookingData.paymentInfo.paymentStatus}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Test Price</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{bookingData.paymentInfo.orderPrice.toFixed(2)}/-</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Collection Price</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{bookingData.paymentInfo.deliveryPrice.toFixed(2)}/-</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: {bookingData.paymentInfo.paymentMode}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total Amount</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold" mt={2}>: ₹{(bookingData.paymentInfo.orderPrice + bookingData.paymentInfo.deliveryPrice).toFixed(2)}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography 
//                     style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }} 
//                     mt={2}
//                     onClick={handleOpenInvoice}
//                   >
//                     📋 View Invoice
//                   </Typography>
//                 </Grid>


//                         {/* ✅ NEW: INVOICE UPLOAD SECTION */}
//         <Grid container spacing={2} mt={3}>
//             <Grid item xs={12}>
//                 <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
//                     <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
//                         💼 Invoice Upload
//                     </Typography>
                    
//                     <Grid container spacing={2}>
//                         <Grid item xs={12} sm={8}>
//                             <WSFileUpload
//                                 control={mainControl}
//                                 name="invoiceFile"
//                                 label="Select Invoice (PDF/JPG/PNG)"
//                                 id="invoiceFile"
//                                 rules={{ required: false }}
//                                 onChange={(files: File[] | null) => {
//                                     if (files && files.length > 0) {
//                                         const file = files[0];
//                                         setInvoiceFile(file);
//                                         console.log('📁 Selected invoice:', file.name);
//                                     }
//                                 }}
//                             />

//                             {invoiceFile && (
//                                 <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
//                                     ✅ Selected: {invoiceFile.name}
//                                 </Typography>
//                             )}
//                         </Grid>
//                         <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
//                             <Button
//                                 variant="contained"
//                                 color="secondary"
//                                 onClick={handleInvoiceUpload}
//                                 disabled={uploadingInvoice || !invoiceFile}
//                                 sx={{ mt: 1.5 }}
//                                 fullWidth
//                             >
//                                 {uploadingInvoice
//                                     ? "⏳ Uploading Invoice..."
//                                     : "🚀 Upload Invoice"
//                                 }
//                             </Button>
//                             {uploadInvoiceSuccess && (
//                                 <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
//                                     ✓ Success
//                                 </Typography>
//                             )}
//                         </Grid>
//                     </Grid>
//                 </Paper>
//             </Grid>
//         </Grid>

//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>
//       </form>

//       {/* Invoice Modal */}
//       <Dialog open={invoiceModalOpen} onClose={() => setInvoiceModalOpen(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <Typography variant="h6">Lab Invoice</Typography>
//           <IconButton onClick={() => setInvoiceModalOpen(false)}>
//             <WSIcons.CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
//           {orderId && <LabInvoiceReport orderId={orderId} />}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// });



import React, { useEffect, useState, useCallback } from "react";
import WSBackButton from "../../../Components/BackButton/BackButton";
import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { LabInvoiceReport } from "./invoice";
import http from "../../../commonFunctions/httpClient";
import configData from '../../../Config/config.json';

// INTERFACES - SAME
interface Timeline {
  orderPlaced: string;
  deliveryAssigned: string | null;
  orderShipped: string | null;
  delivered: string | null;
  status: string;
  technician: string;
}

interface PatientInfo {
  username: string;
  contactNumber: string;
  address: string;
  age: number;
}

interface OrderInfo {
  totalItems: number;
  subtotal: number;
  deliveryFee: number;
  payment: string;
  itemsName: string;
}

interface DeliveryDetails {
  technicianName: string;
  technicianStatus: string;
  deliveryStatus: string;
  orderId: string;
  receivedDateTime: string | null;
  locationUrl: string | null;
  deliveryAddress: string;
  sampleCollectionType: string;
  scheduledate: string;
  startTime: string;
  endTime: string;
}

interface PaymentInfo {
  paymentStatus: string;
  orderPrice: number;
  deliveryPrice: number;
  paymentMode: string;
  invoiceUrl: string;
}

interface PatientTest {
  labBookingServiceId: string;
  labBookingPatientId: string;
  testName: string;
  status: string;
  reportUrl: string;
}

interface BookingPatient {
  patientId: string;
  patientName: string;
  tests: PatientTest[];
}

interface LabBookingDetails {
  timeline: Timeline;
  patient: PatientInfo;
  orderInfo: OrderInfo;
  report: any;
  deliveryDetails: DeliveryDetails;
  paymentInfo: PaymentInfo;
  patients: BookingPatient[];
}

interface ApiResponse {
  status: boolean;
  message: string;
  data: LabBookingDetails;
}

export const LabOrderDetails: React.FC<any> = React.memo((props) => {
  const params = useParams<{ id: string }>();
  const orderId = params?.id;
  
  const mainForm = useForm<any>();
  const { control: mainControl, register: mainRegister, handleSubmit: mainHandleSubmit, setValue: mainSetValue, getValues } = mainForm;

  const [loading, setLoading] = useState<boolean>(false);
  const [bookingData, setBookingData] = useState<LabBookingDetails | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  
  // File upload states
  const [reportFiles, setReportFiles] = useState<{ [key: string]: File | null }>({});
  const [uploadingReports, setUploadingReports] = useState<{ [key: string]: boolean }>({});
  const [uploadSuccess, setUploadSuccess] = useState<{ [key: string]: boolean }>({});

  // INVOICE UPLOAD STATES
  const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
  const [uploadingInvoice, setUploadingInvoice] = useState(false);
  const [uploadInvoiceSuccess, setUploadInvoiceSuccess] = useState(false);
  const imgUrl = configData.imgUrl; 
const getCorrectedReportUrl = (reportUrl: string) => {
  return reportUrl.replace(/^UploadedImages\//, '');
};


  const handleOpenInvoice = () => {
    setInvoiceModalOpen(true);
  };

  const onSubmit = () => {};

  // FETCH DATA
  useEffect(() => {
    const fetchData = async () => {
      if (!orderId) {
        setError("No order ID found in URL");
        return;
      }

      setLoading(true);
      setError(null);

      try {
        console.log(`🔄 Fetching data for orderId: ${orderId}`);
        const response: ApiResponse = await callAPI(
          `lab/LabBooking/LabBooking-details/${orderId}`,
          Method.GET
        );

        console.log("📦 API Response:", response);

        if (response?.status === true && response.data) {
          console.log("✅ Data loaded successfully!");
          setBookingData(response.data);
          mainSetValue("status", response.data.timeline?.status || "");
          setError(null);
        } else {
          console.error("❌ Invalid response:", response);
          setError(`API Error: ${response?.message || "Invalid response structure"}`);
        }
      } catch (err: any) {
        console.error("💥 API Error:", err);
        setError(`Failed to fetch: ${err.message || "Network error"}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [orderId, mainSetValue]);

  // ✅ FIXED: File handlers with react-hook-form COMPATIBILITY
  const handleFileChange = useCallback((labBookingPatientId: string, fieldName: string) => {
    const fileList = getValues(fieldName) as FileList;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      setReportFiles(prev => ({ ...prev, [labBookingPatientId]: file }));
      console.log(`📁 Selected file for ${labBookingPatientId}:`, file.name);
    }
  }, [getValues]);

  // ✅ FIXED: CORRECT API ENDPOINT - PUT /api/lab/LabBooking/upload-report/{labBookingPatientId}
const handleReportUpload = useCallback(async (labBookingPatientId: string, testName: string, fieldName: string) => {
  if (!labBookingPatientId) {
    alert(`❌ Invalid Patient ID for ${testName}`);
    return;
  }

  const fileList = getValues(fieldName) as FileList;
  const file = fileList?.[0];
  if (!file) {
    alert(`Please select a report file for ${testName}`);
    return;
  }

  const userId = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
  if (!userId) {
    alert('❌ UserId not found.');
    return;
  }

  const patientKey = labBookingPatientId;
  setUploadingReports(prev => ({ ...prev, [patientKey]: true }));
  setUploadSuccess(prev => ({ ...prev, [patientKey]: false }));

  try {
    const formData = new FormData();
    formData.append("ReportFile", file);
    formData.append("UpdatedBy", userId);

    console.log('✅ Uploading:', file.name, 'for patient:', labBookingPatientId);

    // 🔥 YOUR PERFECT SOLUTION:
    const response = await callAPI(
      `lab/LabBooking/upload-report/${labBookingPatientId}`,
      Method.PUTFORMDATA,  // ✅ Uses httpClient.putFormData()
      null,
      null,
      formData
    );

    console.log('✅ Response:', response);

    if (response?.success === true) {
      setUploadSuccess(prev => ({ ...prev, [patientKey]: true }));
      alert(`✅ Report uploaded successfully for ${testName}!`);
      mainSetValue(fieldName, null as any);
      setReportFiles(prev => ({ ...prev, [labBookingPatientId]: null }));
      setTimeout(() => window.location.reload(), 1500);
    } else {
      throw new Error(response?.message || 'Upload failed');
    }

  } catch (err: any) {
    console.error('❌ Error:', err);
    alert(`❌ Failed: ${err?.message || 'Please try again'}`);
  } finally {
    setUploadingReports(prev => ({ ...prev, [patientKey]: false }));
    setTimeout(() => setUploadSuccess(prev => ({ ...prev, [patientKey]: false })), 3000);
  }
}, [getValues, mainSetValue]);



  // INVOICE UPLOAD HANDLER
  const handleInvoiceUpload = useCallback(async () => {
    const file = invoiceFile;
    
    if (!file) {
      alert('Please select an invoice file first');
      return;
    }

    if (!orderId) {
      alert('No order ID found');
      return;
    }

    const userId = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
    if (!userId) {
      alert('❌ UserId not found. Please login again.');
      return;
    }

    setUploadingInvoice(true);
    setUploadInvoiceSuccess(false);

    try {
      const formData = new FormData();
      formData.append("file", file);

      console.log('📤 Uploading invoice:', file.name);

     const response = await callAPI(
  `lab/LabBooking/${orderId}/upload-invoice`,
  Method.POST,
  formData
);

console.log('✅ INVOICE UPLOAD Response:', response);

// Success if: has invoiceUrl OR success message OR status true OR no error
const isSuccess = 
  response?.invoiceUrl || 
  response?.message?.includes('successfully') ||
  response?.status === true;

if (isSuccess) {
  setUploadInvoiceSuccess(true);
  alert('✅ Invoice uploaded successfully!');
  setInvoiceFile(null);
  mainSetValue('invoiceFile', null as any);
  setTimeout(() => window.location.reload(), 1500);
} else {
  throw new Error(response?.message || 'Invoice upload failed');
}



    } catch (err: any) {
      console.error('❌ Invoice upload error:', err);
      alert(`❌ Failed to upload invoice: ${err.message || 'Please try again'}`);
    } finally {
      setUploadingInvoice(false);
      setTimeout(() => {
        setUploadInvoiceSuccess(false);
      }, 3000);
    }
  }, [invoiceFile, orderId, mainSetValue]);

  useEffect(() => {
    if (orderId) {
      breadCrumbsStore.updateBreadCrumbs([
        { Orders: "lab-orders/list" },
        { [`Order Details `]: "/" },
      ]);
    }
  }, [orderId]);

  const steps = bookingData
    ? [
        {
          label: "Order Placed",
          completed: bookingData.timeline.orderPlaced !== "OrderPlaced",
          icon: <WSIcons.FiPackage />,
        },
        {
          label: "Technician Assigned",
          completed:
            bookingData.timeline.status !== "OrderPlaced" &&
            bookingData.timeline.technician !== "Not Assigned",
          icon: <WSIcons.TbUserSquareRounded />,
        },
        {
          label: "Sample Collected",
          completed:
            bookingData.timeline.status === "SampleCollected" ||
            bookingData.timeline.status === "Report Generated",
          icon: <WSIcons.RiRidingLine />,
        },
        {
          label: "Report Uploaded",
          completed: bookingData.timeline.status === "Report Generated",
          icon: <WSIcons.BsArrowUpSquare />,
        },
      ]
    : [];

  if (loading) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
        <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Typography>Loading booking details for Order ID: {orderId}...</Typography>
        </Paper>
      </>
    );
  }

  if (error || !bookingData) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
        <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px", backgroundColor: "#fff3cd" }}>
          <Typography variant="h6" color="warning.main" gutterBottom>No Booking Data Found</Typography>
        </Paper>
      </>
    );
  }

  return (
    <>
      <WSBackButton id="btnScheduleBack" url={"/lab-orders/list"} preferHistory />
      <form onSubmit={mainHandleSubmit(onSubmit)}>
        {/* Timeline */}
        <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
            </Grid>
            <Grid item sm={12} xs={12}>
              <WSHorizontalTimeline steps={steps} />
              <Typography color={"GrayText"} variant="caption" style={{ fontWeight: 400, marginTop: 10 }}>
                {bookingData.timeline.orderPlaced}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Order Summary */}
        <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2} mt={2}>
            <Grid item sm={3} xs={12}><Typography>Order ID</Typography></Grid>
            <Grid item sm={3} xs={12}><Typography>Status</Typography></Grid>
            <Grid item sm={3} xs={12}><Typography>Technician</Typography></Grid>
            <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
            <Grid item sm={3} xs={12}><Typography>{bookingData.deliveryDetails.orderId}</Typography></Grid>
            <Grid item sm={3} xs={12}>
              <WSTextField
                label=""
                {...mainRegister("status")}
                id="status"
                name="status"
                control={mainControl}
                rules={{ required: false }}
                sx={{ width: "131px" }}
                defaultValue={bookingData.timeline.status}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <WSTextField
                label=""
                {...mainRegister("technician")}
                id="technician"
                name="technician"
                control={mainControl}
                rules={{ required: false }}
                sx={{ width: "131px" }}
                defaultValue={bookingData.timeline.technician}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* User & Order Info */}
        <Grid container spacing={2} mt={2} sx={{ alignItems: 'stretch' }}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>👤 User Information</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">User Name</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.username}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Age</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.age}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.contactNumber}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.patient.address}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Order ID</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.deliveryDetails.orderId}</Typography></Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>📋 Order Information</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Test Name</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.orderInfo.itemsName}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Order Date & Time</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(bookingData.timeline.orderPlaced).toLocaleString()}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sample Collection Type</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {bookingData.deliveryDetails.sampleCollectionType}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Scheduled Collection Slot</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {`${bookingData.deliveryDetails.scheduledate} ${bookingData.deliveryDetails.startTime} - ${bookingData.deliveryDetails.endTime}`}</Typography></Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Patients & Tests Information */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
                🧪 Patients & Tests Information
              </Typography>
              
              {bookingData.patients.map((bookingPatient, patientIndex) => (
                <React.Fragment key={bookingPatient.patientId}>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <Divider />
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 1 }}>
                      Patient {patientIndex + 1}: {bookingPatient.patientName}
                    </Typography>
                  </Grid>
                  
                  {bookingPatient.tests.map((test) => {
                    const fieldName = `report_${test.labBookingPatientId}`;
                    
                    return (
                      <Grid container key={test.labBookingServiceId} spacing={1} sx={{ pl: 3, mb: 2, pt: 1 }}>
                        {/* Test Info */}
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Test:</Typography>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                          <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>{test.testName}</Typography>
                        </Grid>
                        
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Status:</Typography>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                          <Typography variant="body2" sx={{ fontSize: '0.9rem', fontWeight: 'medium', color: test.status === "ReportGenerated" ? "success.main" : "warning.main" }}>
                            {test.status.replace('ReportGenerated', 'Report Generated')}
                          </Typography>
                        </Grid>

                        {/* Existing Report */}
                        {test.reportUrl && (
  <>
    <Grid item xs={12} sm={3}>
      <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Report:</Typography>
    </Grid>
    <Grid item xs={12} sm={9}>
      <Typography 
        variant="body2"
        sx={{ fontSize: '0.9rem', color: "#098963", cursor: "pointer", textDecoration: "underline", '&:hover': { color: "#0a7a52" } }}
        onClick={() => {
          const filename = getCorrectedReportUrl(test.reportUrl);
          const pdfUrl = `${imgUrl}/${filename}`;
          console.log('📄 LabReport style - Opening:', pdfUrl);
          
          const newWindow = window.open(pdfUrl, '_blank', 'noopener,noreferrer');
          if (!newWindow) {
            alert('Please allow popups to view the report');
          }
        }}
      >
        📄 View Report
      </Typography>
    </Grid>
  </>
)}


                        {/* File Upload */}
                        <Grid item xs={12}>
                          <Divider sx={{ my: 1 }} />
                          <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem', mt: 1 }}>
                            Upload New Report:
                          </Typography>
                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12} sm={8}>
                              <WSFileUpload
                                control={mainControl}
                                name={fieldName}
                                label="Select Report File (PDF/JPG/PNG)"
                                id={fieldName}
                                rules={{ required: false }}
                                onChange={() => handleFileChange(test.labBookingPatientId, fieldName)}
                              />
                              {reportFiles[test.labBookingPatientId] && (
                                <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
                                  ✅ Selected: {reportFiles[test.labBookingPatientId]?.name}
                                </Typography>
                              )}
                            </Grid>
                            <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleReportUpload(test.labBookingPatientId, test.testName, fieldName)}
                                disabled={uploadingReports[test.labBookingPatientId] || !reportFiles[test.labBookingPatientId]}
                                sx={{ mt: 1.5 }}
                              >
                                {uploadingReports[test.labBookingPatientId] 
                                  ? "⏳ Uploading..." 
                                  : "🚀 Upload Report"
                                }
                              </Button>
                              {uploadSuccess[test.labBookingPatientId] && (
                                <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
                                  ✓ Success
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
                </React.Fragment>
              ))}
            </Paper>
          </Grid>
        </Grid>

        {/* Payment Information & Invoice Upload */}
        <Grid container spacing={2} mt={3}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px", height: "auto", minHeight: "24rem" }}>
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>💰 Payment Information</Typography>
                </Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: {bookingData.paymentInfo.paymentStatus}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Test Price</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{bookingData.paymentInfo.orderPrice.toFixed(2)}/-</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Collection Price</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{bookingData.paymentInfo.deliveryPrice.toFixed(2)}/-</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: {bookingData.paymentInfo.paymentMode}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total Amount</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold" mt={2}>: ₹{(bookingData.paymentInfo.orderPrice + bookingData.paymentInfo.deliveryPrice).toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
                <Grid item xs={12} sm={8}>
                  <Typography 
                    style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }} 
                    mt={2}
                    onClick={handleOpenInvoice}
                  >
                    📋 View Invoice
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px", height: "100%" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
                💼 Invoice Upload
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <WSFileUpload
                    control={mainControl}
                    name="invoiceFile"
                    label="Select Invoice (PDF/JPG/PNG)"
                    id="invoiceFile"
                    rules={{ required: false }}
                    onChange={(files: File[] | null) => {
                      if (files && files.length > 0) {
                        const file = files[0];
                        setInvoiceFile(file);
                        console.log('📁 Selected invoice:', file.name);
                      }
                    }}
                  />

                  {invoiceFile && (
                    <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
                      ✅ Selected: {invoiceFile.name}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleInvoiceUpload}
                    disabled={uploadingInvoice || !invoiceFile}
                    sx={{ mt: 1.5 }}
                    fullWidth
                  >
                    {uploadingInvoice
                      ? "⏳ Uploading Invoice..."
                      : "🚀 Upload Invoice"
                    }
                  </Button>
                  {uploadInvoiceSuccess && (
                    <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
                      ✓ Success
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </form>

      {/* Invoice Modal */}
      <Dialog open={invoiceModalOpen} onClose={() => setInvoiceModalOpen(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6">Lab Invoice</Typography>
          <IconButton onClick={() => setInvoiceModalOpen(false)}>
            <WSIcons.CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
          {orderId && <LabInvoiceReport orderId={orderId} />}
        </DialogContent>
      </Dialog>
    </>
  );
});
